<template>
  <div style="display:flex;position:relative">
    <video
      :style="`max-height:${maxHeight};min-height:${minHeight};margin:auto;display:block`"
      autoplay
      :src="videoSrc"
    ></video>
    <v-overlay absolute>
      <v-btn
        v-if="!inUploadingVideo"
        @click="$refs.selectVideoGalleryChild.click()"
        small
      >
        <v-icon>fas fa-video</v-icon>
      </v-btn>
      <input
        type="file"
        @change="selectedVideo($event)"
        style="display:none"
        accept="video/*"
        ref="selectVideoGalleryChild"
      />
      <v-progress-circular
        width="2"
        v-show="inUploadingVideo"
        color="blue darken-3"
        :value="videoUploadProgress"
        size="80"
      >
        <span style="color:#fff">{{ videoUploadProgress }}%</span>
      </v-progress-circular>
    </v-overlay>
  </div>
</template>
 
<script>
const axios = require("axios");
export default {
    props:{
      uploadUrl:{type:String},
      UploadPath:{type:String},
      minHeight:{type:String,default:"430px"},
      maxHeight:{type:String,default:"430px"},
      },
  name: "videoUploader",
  data: () => ({
    videoSrc: "",
    inUploadingVideo:false,
    videoUploadProgress:0,
    videoUrl:""
  }),
  created()
  {
      let vm = this;
      vm.videoSrc = vm.$store.getters.getGalleryChild;
  },
  methods: {
    async selectedVideo(e)
    {
      let vm = this;
   
      var f = URL.createObjectURL(e.target.files[0]);
      var data = new FormData();
      data.append("file",e.target.files[0]);
      vm.inUploadingVideo = true;
      var url=vm.uploadUrl+'/'+vm.UploadPath;
      alert(url);
      const config = {
            onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            vm.videoUploadProgress = percentCompleted;
            }
        }
      await axios.post(url,data,config)
        .then(function (res) {
          console.log(res);
            vm.inUploadingVideo = false;
            if(res.data.status)
            {
              vm.videoUrl = res.data.data;
              vm.EmitData();
            }
        })
        .catch(function (error) {
         vm.inUploadingVideo = false;
          console.log(error);
        });
      this.videoSrc = f;
    },
    EmitData()
    {
        this.$emit("SavedFileName",this.videoUrl);
    },
  }
};
</script> 